import { useState } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import routes from 'routes';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Layout components
import { SidebarContext } from 'contexts/SidebarContext';

// Custom Chakra theme
export default function Auth() {
  // states and functions
  const [toggleSidebar, setToggleSidebar] = useState(false);

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route: RoutesType, key: any) => {
      if (route.layout === '/auth') {
        return <Route path={route.path} element={route.component} key={key} />;
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = 'ltr';
  return (
    <>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Box
          float="right"
          position="relative"
          w="100%"
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Box minH="100vh">
            <Routes>
              {getRoutes(routes)}
              <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
            </Routes>
          </Box>
        </Box>
      </SidebarContext.Provider>
    </>
  );
}
